import { render, staticRenderFns } from "./sub_acc_download_app.vue?vue&type=template&id=2d897c02&"
import script from "./sub_acc_download_app.vue?vue&type=script&lang=js&"
export * from "./sub_acc_download_app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports